/**
 * @generated SignedSource<<81f90b52dd3ab0c9ce15e62a1ed0e71d>>
 * @relayHash 406c96990586208cebc102afe6c5ebff
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 406c96990586208cebc102afe6c5ebff

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Ccn",
    "kind": "LinkedField",
    "name": "ccns",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shortTitle",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CcnsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CcnsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "406c96990586208cebc102afe6c5ebff",
    "metadata": {},
    "name": "CcnsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "5caf67d15b33b84a144e2af43dd407c3";

export default node;
